export default "__VITE_ASSET__BTrkCzQF__"